<ui-modal
  class="medusa-login-modal"
  [isOpened]="isModalOpened"
  modalTitle="Issue with Medusa login"
  (isOpenedChange)="modalChanged()"
>
  <div class="medusa-login-container">
    <form
      class="medusa-login-container__form"
      #loginForm="ngForm"
      (ngSubmit)="login()"
    >
      <div class="medusa-login-container__form__title">
        Please enter password for Medusa User: {{ medusaAccount.userId }}
      </div>
      <div class="medusa-login-container__form__text-box-container">
        <div class="clr-control-container">
          <div class="clr-input-wrapper">
            <input
              placeholder="Password"
              name="password"
              required
              input
              type="password"
              [(ngModel)]="password"
              autocomplete="off"
              class="clr-input"
            />
          </div>
        </div>
      </div>
      <div class="medusa-login-container__form__footer">
        <button
          class="
            ui-button
            primary
            medusa-login-container__form__footer__login-button
          "
          [disabled]="!loginForm.valid"
        >
          <ng-container *ngIf="!attemptingToLogin; else showSpinner">
            Login
          </ng-container>

          <ng-template #showSpinner>
            <span class="spinner spinner-sm spinner-inverse"> </span>
          </ng-template>
        </button>
      </div>
    </form>
  </div>
</ui-modal>
